import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "defaultChecked", "value", "valueChange", "onChange", "label", "checkboxClass", "error", "errMessage", "textCustomStyles"],
    _excluded2 = ["name", "control", "rules", "defaultValue", "valueChange", "containerClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useState } from 'react';
import { Box, Checkbox, FormControlLabel, FormHelperText } from '@mui/material';
import clsx from 'clsx';
import { useController } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var JoveCheckbox = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      defaultChecked = props.defaultChecked,
      value = props.value,
      valueChange = props.valueChange,
      onChange = props.onChange,
      label = props.label,
      checkboxClass = props.checkboxClass,
      error = props.error,
      errMessage = props.errMessage,
      textCustomStyles = props.textCustomStyles,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(Boolean(defaultChecked)),
      checked = _useState[0],
      setChecked = _useState[1];

  var checkedChangeAction = function checkedChangeAction(e, checked) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e, checked);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(checked);
    setChecked(checked);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [/*#__PURE__*/_jsx(Box, {
      className: "flex flex-row items-center",
      children: /*#__PURE__*/_jsx(FormControlLabel, {
        control: /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({}, rest), {}, {
          ref: ref,
          className: clsx('py-0', checkboxClass),
          checked: value === undefined ? checked : Boolean(value),
          defaultChecked: defaultChecked,
          onChange: checkedChangeAction
        })),
        label: label,
        sx: {
          alignItems: 'flex-start',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          '& .MuiTypography-body1': _objectSpread({}, textCustomStyles),
          '& .MuiCheckbox-root': {
            paddingRight: !!label ? '9px' : 0
          },
          marginRight: !!label ? '16px' : 0
        }
      })
    }), error && /*#__PURE__*/_jsx(FormHelperText, {
      error: error,
      children: errMessage
    })]
  });
});
export var JoveCheckboxControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      containerClassName = props.containerClassName,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var valueChangeAction = function valueChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveCheckbox, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      defaultChecked: defaultValue,
      valueChange: valueChangeAction,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveCheckbox;